import React from 'react';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { ILearningCenterCategoryTileFields } from '../../../../../types/contentful';
import { CategoryLink, CategoryTileWrapper, Title } from './styles';
import { getCategorySlug } from '../shared';
import areaIcon from '@/images/icon-area.svg';
import barsIcon from '@/images/icon-bars.svg';
import { LinearGradientToken } from '../../../../theme/tokens/linear-gradient';

interface CategoryTileProps extends ILearningCenterCategoryTileFields {
  color: LinearGradientToken;
}

export function CategoryTile({
  title,
  icon,
  category,
  color
}: CategoryTileProps) {
  const router = useRouter();
  const href = router.asPath.includes('learning-center')
    ? `/learning-center/${getCategorySlug(category)}`
    : `/partner-resources/${getCategorySlug(category)}`;
  const image = icon === 'Area' ? areaIcon : barsIcon;
  const IMAGE_SIZE = 64;

  return (
    <CategoryTileWrapper color={color} data-testid="category-tile">
      <CategoryLink href={href}>
        <Image
          alt=""
          src={image}
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
        />
        <Title>{title}</Title>
      </CategoryLink>
    </CategoryTileWrapper>
  );
}
